// Group Report Template Builder Main State

import { GroupReportsTemplateModel } from './groupTemplate.model';

export const groupReportsFeatureKey = 'group-report-template';

export interface GroupTemplateState {
  template: GroupReportsTemplateModel | null;
  selectedTemplate: number;
  loading: boolean;
  error: string | null;
  isNew: boolean;
  templateValidation: {
    surveyInvalid: boolean;
    templateNameInvalid: boolean;
  };
}

export const initialTemplateState: GroupTemplateState = {
  template: null,
  selectedTemplate: 0,
  loading: false,
  error: null,
  isNew: false,
  templateValidation: {
    surveyInvalid: false,
    templateNameInvalid: false,
  },
};
